import Icon from '../components/Icon.vue'

Icon.register({
  suitcase: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M128 480v-400c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v400h-256zM192 96v32h128v-32h-128zM512 176v256c0 26.5-21.5 48-48 48h-48v-352h48c26.5 0 48 21.5 48 48zM96 480h-48c-26.5 0-48-21.5-48-48v-256c0-26.5 21.5-48 48-48h48v352z'
      }
    ]
  }
})
